import React from 'react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer minimal-footer">
      {/* Floating Particles */}
      <div className="footer-particles">
        <div className="particle"></div>
        <div className="particle"></div>
        <div className="particle"></div>
      </div>

      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-info">
              <h3>Dr. Dipti Vashisth Sharma</h3>
              <p>PhD Economics | Research Scholar | Academic Professional</p>
            </div>
            <div className="footer-contact-mini">
              <a href="mailto:vs.dipti@gmail.com">vs.dipti@gmail.com</a>
              <span>•</span>
              <a href="tel:+918805352101">+91 8805352101</a>
              <span>•</span>
              <span>Pune, India</span>
            </div>

          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>&copy; {currentYear} Dr. Dipti Vashisth Sharma. All rights reserved.</p>
          </div>
          <div className="footer-achievements">
            <span>34+ Research Papers</span>
            <span>•</span>
            <span>3 Patents</span>
            <span>•</span>
            <span>2 Books</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;